import { Equal, IQueryCommandOptions, ISearchCommandOptions, Not, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorPresets } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IApiResponse, IMetaResponse } from '@/shared';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_presets';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    { path: 'floorplanNavigatorInstances', alias: 'fpni' },
    { path: 'fpni.buildings', alias: 'b' },
    { path: 'fpni.sitesHasFloorplanNavigatorInstances', alias: 'shfpni', whereCommands: [ Not(Equal('status', 'deleted')) ] },
  ],
  select: [
    'id',
    'clientId',
    'name',
    'noResults',
    'unitModalTitle',
    'unitModalSubTitle',
    'floorSelectSubTitle',
    'showAvailableUnits',
    'showAvailableOnUnits',
    'showUnavailableUnits',
    'showWaitlistUnits',
    'removeEmptyFields',
    'showUnavailableFloors',
    'sortBy',
    'dateFormat',
    'fpni.id',
    'fpni.buildingId',
    'fpni.key',
    'fpni.buildingImage',
    'fpni.styles',
    'fpni.floors',
    'b.buildingName',
    'shfpni.siteId',
    'instanceCount',
  ],
  aggregations: [{
    table: 'floorplan_navigator_instances',
    propertyAlias: 'instanceCount',
    column: 'id',
    aggregate: 'COUNT',
    whereCommands: [
      Equal('floorplanNavigatorPresetId', 'fpnp.id'),
    ],
  }],
  where: [
    Not(Equal('fpnp.status', 'deleted')),
  ],
  alias: 'fpnp',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
  select: [
    'id',
    'clientId',
    'name',
    'noResults',
    'unitModalTitle',
    'unitModalSubTitle',
    'floorSelectSubTitle',
    'showAvailableUnits',
    'showAvailableOnUnits',
    'showUnavailableUnits',
    'showWaitlistUnits',
    'removeEmptyFields',
    'showUnavailableFloors',
    'sortBy',
    'dateFormat',
  ],
  alias: 'fpnp',
};
const base = new StoreBaseImplementationV2<Partial<IFloorplanNavigatorPresets>>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    async getLayoutNames(
      ctx: ActionContext<any, (typeof base.state)>,
      payload: { clientId: number },
    ) {
      const query = {
        alias: 'fs',
        selectDistinct: 'fs.layout',
        where: [
          Equal('fs.clientId', payload.clientId),
        ],
        limit: 999,
      } as ISearchCommandOptions;
      const result: IApiResponse<any[], IMetaResponse> = await adminRequest.get(`${adminGatewayResourcePath}/`, convertQueryCommandToQueryString(query));
      return result.data ?? [];
    },
    async getTemplateNames(
      ctx: ActionContext<any, (typeof base.state)>,
      payload: { clientId: number },
    ) {
      const query = {
        alias: 'fs',
        select: ['fs.id', 'fs.name'],
        where: [
          Equal('fs.clientId', payload.clientId),
        ],
        limit: 999,
      } as ISearchCommandOptions;
      const result: IApiResponse<any[], IMetaResponse> = await adminRequest.get(`${adminGatewayResourcePath}/`, convertQueryCommandToQueryString(query));
      return result.data ?? [];
    },
    async saveAddionalSettings(
      ctx: ActionContext<any, (typeof base.state)>,
      payload: IFloorplanNavigatorPresets,
    ): Promise<void> {
      const result: IApiResponse<any[], IMetaResponse> = await adminRequest.post(`${adminGatewayResourcePath}/`, payload);
    },
  },
};
